import styled from 'styled-components';
import { Path, PathProps } from './Path';
import { getCssVar } from '../../common/utils';

export const StyledSvg = styled.svg`
  width: 100%;
  vertical-align: middle;
`;

export const StyledTrailPath = styled(Path)<PathProps>`
  stroke: #d6d6d6;
  stroke-linecap: round;
`;

export const StyledPath = styled(Path)<PathProps>`
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease 0s;
`;

export const StyledText = styled.text`
  font-size: 22px;
  line-height: 30px;
  font-weight: 600;
  dominant-baseline: central;
  text-anchor: middle;

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-lg', '1600px')}) {
    font-size: 22px !important;
    line-height: 30px !important;
  }

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-xl', '1920px')}) {
    font-size: 22px !important;
    line-height: 40px !important;
  }
`;
